import request from "@/router/axios";

export const add = (row) => {
  return request({
    url: "/api/produce/inspectionrole/insert",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/produce/inspectionrole/update",
    method: "post",
    data: row,
  });
};

export const getList = (params) => {
  return request({
    url: "/api/produce/inspectionrole/select/page",
    method: "get",
    params,
  });
};

export const remove = (roleIds) => {
  return request({
    url: "/api/produce/inspectionrole/delete/ids",
    method: "get",
    params: {
      roleIds,
    },
  });
};
